import { StyledText } from '../../Atoms/Text/styles'
import { StyledTextarea } from '../../Atoms/Textarea/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledTextInputSurrounded = styled('div', {
    w: '100%',
    whiteSpace: 'pre-line',

    [`& ${StyledTextarea}`]: {
        borderColor: '$neutral50',

        '&:focus': {
            borderColor: '$neutral50',
        },

        '&::-webkit-scrollbar': {
            w: 14,
        },

        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 10px 10px $colors$neutral200',
            border: '4px solid transparent',
            br: '$2',
        },

        '&::-webkit-scrollbar-thumb': {
            boxShadow: 'inset 0 0 10px 10px $colors$neutral500',
            border: '4px solid transparent',
            br: '$2',
        },
    },

    [`& ${StyledText}`]: {
        bgc: '$neutral50',
        br: '$1',
        color: '$neutral400',
        display: 'block',
        maxH: 0,
        opacity: 0,
        px: '$3',
        transition: '$default',
        visibility: 'hidden',

        '&:first-of-type': {
            borderBottom: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },

        '&:last-of-type': {
            borderTop: 'none',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
    },

    variants: {
        showText: {
            true: {
                [`& ${StyledTextarea}`]: {
                    br: 0,
                },

                [`& ${StyledText}`]: {
                    maxH: 100,
                    opacity: 1,
                    visibility: 'visible',

                    '&:first-of-type': {
                        pb: 0,
                        pt: '$2',
                    },

                    '&:last-of-type': {
                        pt: 0,
                        pb: '$2',
                    },
                },
            },
        },
    },
})

export const StyledSurroundedTextArea = styled(StyledTextarea, {
    overflow: 'hidden',
    pointerEvents: 'none',

    variants: {
        onFocus: {
            true: {
                maxH: 100,
            },
            false: {
                maxH: '0',
                py: '0',
            },
        },
    },
})
